import { render, staticRenderFns } from "./ProcessModel.vue?vue&type=template&id=2bf0ddcd&scoped=true"
import script from "./ProcessModel.vue?vue&type=script&lang=js"
export * from "./ProcessModel.vue?vue&type=script&lang=js"
import style0 from "./ProcessModel.vue?vue&type=style&index=0&id=2bf0ddcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0ddcd",
  null
  
)

export default component.exports